import { fork } from 'redux-saga/effects';

import visitsSaga from './visits/saga';
import reportsSaga from './reports/saga';
import patientsSaga from './patients/saga';
import consultationsQueueSaga from './consultationsQueue/saga';
import practitionersSaga from './practitioners/saga';
import ordersSaga from './orders/saga';
import transactionsSaga from './transactions/saga';
import statesSaga from './states/saga';
import settingsSaga from './settings/saga';
import productVariationsSaga from './productVariations/saga';
import productsSags from './products/saga';
import projectsSaga from './projects/saga';
import auth from './auth/saga';
import affiliateAdminsSaga from './affiliateAdmins/saga';
import webhooksSaga from './webhooks/saga';
import questionnairesSaga from './questionnaires/saga';
import pharmaciesSaga from './pharmacies/saga';
import communicationTemplatesSaga from './communicationTemplates/saga';
import labOrdersSaga from './labOrders/saga';
import labPanelsSaga from './labPanels/saga';
import labsSaga from './labs/saga';
import noteTemplatesSaga from './noteTemplates/saga';
import chatSaga from './chat/saga';
import supplies from './supplies/saga';
import tagsSaga from './tags/tags.saga';
import journeyTemplateSaga from './journeyTemplate/saga';
import productSaga from './product/saga';
import subscriptionSaga from './subscription/saga';
import ecommerceOrderSaga from './ecommerceOrder/saga';
import credentialsSaga from './ctrlcredentials/credentials.saga';
import couponSaga from './coupon/saga';

export default function* () {
  yield fork(auth);
  yield fork(reportsSaga);
  yield fork(patientsSaga);
  yield fork(visitsSaga);
  yield fork(consultationsQueueSaga);
  yield fork(practitionersSaga);
  yield fork(ordersSaga);
  yield fork(transactionsSaga);
  yield fork(statesSaga);
  yield fork(settingsSaga);
  yield fork(productVariationsSaga);
  yield fork(productsSags);
  yield fork(projectsSaga);
  yield fork(affiliateAdminsSaga);
  yield fork(webhooksSaga);
  yield fork(questionnairesSaga);
  yield fork(pharmaciesSaga);
  yield fork(communicationTemplatesSaga);
  yield fork(labOrdersSaga);
  yield fork(labPanelsSaga);
  yield fork(labsSaga);
  yield fork(noteTemplatesSaga);
  yield fork(chatSaga);
  yield fork(supplies);
  yield fork(tagsSaga);
  yield fork(journeyTemplateSaga);
  yield fork(productSaga);
  yield fork(subscriptionSaga);
  yield fork(ecommerceOrderSaga);
  yield fork(credentialsSaga);
  yield fork(couponSaga);
}
